import $ from 'jquery';

class ContentsDropdown {
    constructor() {
        this.$hamburger = $('.js-hamburger');
        this.$close = $('.js-hamburger-close');
        this.$overlay = $('.js-contents-dropdown');

        this.$hamburger.on('click', $.proxy(this.buttonClick, this));
        this.$close.on('click', $.proxy(this.buttonClick, this));
    }

    buttonClick(e) {
        e.preventDefault();
        const $elem = $(e.currentTarget);

        this.$hamburger.toggleClass('is-cross');
        this.$close.toggleClass('is-cross');

        this.$overlay.toggleClass('is-open');
    }
}

export default ContentsDropdown;
